import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-vehicles-history',
	templateUrl: './vehicles-history.component.html',
	styleUrls: ['./vehicles-history.component.css'],
})
export class VehiclesHistoryComponent implements OnInit {
	id: string;

	constructor(private readonly route: ActivatedRoute) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			return;
		}
		this.id = this.route.snapshot.params['id'];
	}
}
